import { ServiceType } from '../../../global/api/models';
import {
    getApiHost,
    serviceRequest,
} from '../../../global/api/public/utils';
import { PaginatedListResult } from '../../../global/models';
import {
    Designation,
    DesignationLite,
    DesignationLiteCore,
} from '../shared/models';

export const getDefaultDesignation = async (): Promise<Designation> => {
    const { data } = await serviceRequest({
        url: `${getApiHost(ServiceType.Giving)}/api/designation/default`,
        method: 'GET',
    });

    return data as Designation;
};

export const getDesignations = async (): Promise<DesignationLite[]> => {
    const { data } = await serviceRequest({
        url: `${getApiHost(ServiceType.Giving)}/api/designation?pageSize=1000`, // Just need a really big page size.  API is paginated, but we want "all" Designations to list in a drop-down menu.
        method: 'GET',
    });

    return data?.results as DesignationLite[] ?? [];
};

export const getDesignationsFromCore =
    async (): Promise<PaginatedListResult<DesignationLiteCore>> => {
        const { data } = await serviceRequest({
            url: `${getApiHost(ServiceType.Core)}/api/v4/giving/designations?pageSize=1000`, // Just need a really big page size.  API is paginated, but we want "all" Designations to list in a drop-down menu.
            method: 'GET',
        });

        return data as PaginatedListResult<DesignationLiteCore>;
    };

export const getDesignationDetails = async (designationId: number): Promise<Designation> => {
    const { data } = await serviceRequest({
        url: `${getApiHost(ServiceType.Giving)}/api/designation/${designationId}`,
        method: 'GET',
    });

    return data as Designation;
};
